import { lazyLoad } from 'utils/loadable';

export const DocumentConvert = lazyLoad(
  () => import('./index'),
  module => {
    return module.DocumentConvert;
  },
);
